// Data
import db from './db';

export const getRecountCount = async (table) => {
  return await db[table].count();
}

export const getContentCount = async (content_type) => {
  return await db.contentCounter.where('content_type').equals(content_type).toArray();
}